// TODO(russ-review): blurb copy pending Russ's voice/accuracy review

export type RelatedKey =
  | '/'
  | '/bass-lessons/what-i-teach'
  | '/bass-lessons/testimonials'
  | '/bass-lessons/play-along-tracks'
  | '/bass-lessons/zoom-setup'
  | '/about/bio'
  | '/about/resume'
  | '/about/credits'
  | '/about/discography'
  | '/about/performance'
  | '/about/gear';

export interface RelatedTile {
  title: string;
  blurb: string;
  cta: string;
  href: RelatedKey;
}

export const RELATED_TILES: Record<RelatedKey, RelatedTile> = {
  '/': {
    title: 'Online Lessons',
    blurb:
      'How live one-on-one lessons over Zoom actually work, and what to expect.',
    cta: 'See how it works',
    href: '/',
  },
  '/bass-lessons/what-i-teach': {
    title: 'What I Teach',
    blurb: 'The five foundations Russ builds every student around, and why.',
    cta: 'Explore the method',
    href: '/bass-lessons/what-i-teach',
  }, // from home
  '/bass-lessons/testimonials': {
    title: 'Testimonials',
    blurb: 'What students say after studying with Russ.',
    cta: 'Read student stories',
    href: '/bass-lessons/testimonials',
  },
  '/bass-lessons/play-along-tracks': {
    title: 'Play-Along Tracks',
    blurb: 'Free backing tracks to practice with, by key and feel.',
    cta: 'Grab the tracks',
    href: '/bass-lessons/play-along-tracks',
  },
  '/bass-lessons/zoom-setup': {
    title: 'Zoom Setup',
    blurb: 'The gear and audio settings for clear sound on a video lesson.',
    cta: 'Set up Zoom',
    href: '/bass-lessons/zoom-setup',
  },
  '/about/bio': {
    title: 'About Russ',
    blurb: 'Fifty years on bass, and how Russ came to teach.',
    cta: 'Read his story',
    href: '/about/bio',
  },
  '/about/resume': {
    title: 'Resume',
    blurb: "Russ's teaching and performance background in full.",
    cta: 'See the resume',
    href: '/about/resume',
  },
  '/about/credits': {
    title: 'Credits',
    blurb: 'The artists and stages Russ has played.',
    cta: 'See the credits',
    href: '/about/credits',
  },
  '/about/discography': {
    title: 'Discography',
    blurb: 'Records Russ has played on, with audio.',
    cta: 'Hear the records',
    href: '/about/discography',
  },
  '/about/performance': {
    title: 'Performance',
    blurb: 'Booking Russ for live and recorded bass work.',
    cta: 'About performance',
    href: '/about/performance',
  },
  '/about/gear': {
    title: 'Gear',
    blurb: 'The basses, amps, and pedals Russ plays.',
    cta: 'See the gear',
    href: '/about/gear',
  },
};
